import { render, staticRenderFns } from "./ChildItem.vue?vue&type=template&id=192714a9&scoped=true&"
import script from "./ChildItem.vue?vue&type=script&lang=js&"
export * from "./ChildItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192714a9",
  null
  
)

export default component.exports